var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"workPoolItem",staticStyle:{"position":"relative"}},[_c('el-tabs',{on:{"tab-click":_vm.tabToggle}},[_c('el-tab-pane',{attrs:{"label":"B角职位"}})],1),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.toggleName === 'B角职位'),expression:"toggleName === 'B角职位'"}]},[_c('viewList',{attrs:{"listType":"brole"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }